import { ApisauceConfig } from 'apisauce'
import api, { responseErrorCheck } from './api'
import TmrBaseResource from './TmrBaseResource'

export default class CustomTubful extends TmrBaseResource {
  static endpoint = '/'

  static getTubfulByOrderCode(orderCode: string, params = {}) {
    return api
      .get<any>(`/custom/items/vascata/order/${orderCode}`, params)
      .then(responseErrorCheck)
      .then((res) => res)
  }
}
